/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Lembaga_D4dInputs */

const en_mk_sol_lembaga_d4d = /** @type {(inputs: Mk_Sol_Lembaga_D4dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anything the public will read waits for an authorised yes, and that decision is recorded.`)
};

const id_mk_sol_lembaga_d4d = /** @type {(inputs: Mk_Sol_Lembaga_D4dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa pun yang akan dibaca publik menunggu persetujuan orang yang berwenang, dan keputusannya tercatat.`)
};

/**
* | output |
* | --- |
* | "Anything the public will read waits for an authorised yes, and that decision is recorded." |
*
* @param {Mk_Sol_Lembaga_D4dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_lembaga_d4d = /** @type {((inputs?: Mk_Sol_Lembaga_D4dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Lembaga_D4dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_lembaga_d4d(inputs)
	return en_mk_sol_lembaga_d4d(inputs)
});